<div class="icons screen-element {{classes}}" [ngClass]="{'debug':debug}">
	<div class="icon iconOperationTimeGrey" *ngIf="timerActive()" [ngClass]="{'debug':debug}"></div>	
	<div class="icon iconGreenIQGrey" *ngIf="greenIq()" [ngClass]="{'debug':debug}"></div>	
	<div class="icon iconRadioConnectionGrey" *ngIf="hasRadio()" [ngClass]="{'debug':debug}"></div>	
	<div class="icon iconBatteryFullGrey" *ngIf="hasBattery()" [ngClass]="{'debug':debug}"></div>	
	<div class="icon iconCompetentPersonInstallerGrey" *ngIf="serviceDateExpired()" [ngClass]="{'debug':debug}"></div>	
	<div class="icon iconContactGrey" *ngIf="serviceDateExpired()" [ngClass]="{'debug':debug}"></div>
</div>